import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { contabilidadService } from '../services/contabilidadService';
import type { Socio } from '../types';

export const SOCIOS_QUERY_KEY = ['contabilidad', 'socios'] as const;

export function useSocios() {
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery<Socio[]>({
    queryKey: SOCIOS_QUERY_KEY,
    queryFn: () => contabilidadService.listSocios(),
    staleTime: 1000 * 60 * 5,
  });

  const saveMutation = useMutation({
    mutationFn: (socios: Socio[]) => contabilidadService.saveSocios(socios),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: SOCIOS_QUERY_KEY });
    },
  });

  return {
    socios: data ?? [],
    isLoading,
    error,
    saveSocios: saveMutation.mutateAsync,
    isSaving: saveMutation.isPending,
  };
}
